import { useGetServiceRulesQuery, type Service } from '@generated/graphql';
import { useEditRulesModal } from './EditRulesModal';
import { RulesCard } from './RulesCard';

type ServiceRulesCardProps = Pick<Service, 'serviceId' | 'name'> & {
  startOpen?: boolean;
};

export const ServiceRulesCard = ({ serviceId, name, startOpen = false }: ServiceRulesCardProps) => {
  const { data: serviceRulesData } = useGetServiceRulesQuery({
    variables: { serviceId },
    skip: !serviceId,
  });
  const serviceRules = serviceRulesData?.getServiceRules || '';

  const { showEditRulesModal } = useEditRulesModal({
    componentProps: { serviceId, reloadKey: 'service-edit-rules' },
    modalProps: {
      title: 'Edit service rules',
    },
  });
  const handleEdit = () => {
    showEditRulesModal({ currentRules: serviceRules });
  };

  return (
    <RulesCard
      rules={serviceRules}
      source="service"
      startOpen={startOpen}
      title={`${name} service`}
      onEdit={handleEdit}
    />
  );
};
